(function() {
  /* Hamburger menu toggle (homepage) */
  var menuToggle = document.getElementById('home-menu-toggle');
  var menuDrawer = document.getElementById('home-menu-drawer');
  var menuClose = document.getElementById('home-menu-close');

  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener('click', function() {
      var isOpen = menuDrawer.classList.toggle('is-open');
      menuToggle.classList.toggle('is-open', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    if (menuClose) {
      menuClose.addEventListener('click', function() {
        menuDrawer.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.focus();
      });
    }

    document.addEventListener('click', function(e) {
      if (menuDrawer.classList.contains('is-open') &&
          !menuDrawer.contains(e.target) &&
          !menuToggle.contains(e.target)) {
        menuDrawer.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });

    /* Escape schliesst das Menue (Barrierefreiheit) */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menuDrawer.classList.contains('is-open')) {
        menuDrawer.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.focus();
      }
    });
  }

  /* Product page: thumbnail switching */
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-product-thumb]');
    if (thumb) {
      e.preventDefault();
      var src = thumb.getAttribute('data-product-thumb');
      var mainImg = document.getElementById('product-main-image');
      if (mainImg) {
        mainImg.src = src;
      }
      var allThumbs = thumb.parentElement.querySelectorAll('[data-product-thumb]');
      allThumbs.forEach(function(t) {
        t.classList.remove('product-gallery__thumb--active');
      });
      thumb.classList.add('product-gallery__thumb--active');
    }
  });

  /* Cart: quantity update */
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-cart-qty]')) {
      var form = e.target.closest('form');
      if (form) form.submit();
    }
  });

  /* Cart: remove item */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (btn) {
      var key = btn.getAttribute('data-cart-remove');
      var input = document.querySelector('input[name="updates[' + key + ']"]');
      if (input) {
        input.value = '0';
        input.closest('form').submit();
      }
    }
  });

  /* Countdown: letzte Stunden live herunterzaehlen */
  var cdEls = document.querySelectorAll('[data-jc-countdown]');
  if (cdEls.length) {
    var tick = function() {
      var now = Date.now();
      cdEls.forEach(function(el) {
        var end = Date.parse(el.getAttribute('data-jc-countdown'));
        if (isNaN(end)) return;
        var diff = end - now;
        var out = el.querySelector('[data-jc-countdown-text]');
        if (!out) return;
        if (diff <= 0) { out.textContent = 'Nicht mehr verfügbar'; return; }
        if (diff < 86400000) {
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          out.textContent = 'Nur noch ' + h + ' Std. ' + m + ' Min. verfügbar';
          el.classList.add('jc-countdown--urgent');
        }
      });
    };
    tick();
    setInterval(tick, 60000);
  }

  /* Ankuendigungsleiste: Schliessen merken */
  var ann = document.getElementById('jc-announcement');
  if (ann) {
    var annKey = 'jc-ann-' + (ann.getAttribute('data-ann-key') || '');
    try {
      if (sessionStorage.getItem(annKey) === '1') {
        ann.remove();
        document.documentElement.style.setProperty('--announcement-h', '0px');
      }
    } catch (err) {}
    var annClose = ann.querySelector('[data-ann-close]');
    if (annClose) {
      annClose.addEventListener('click', function() {
        ann.remove();
        document.documentElement.style.setProperty('--announcement-h', '0px');
        try { sessionStorage.setItem(annKey, '1'); } catch (err) {}
      });
    }
  }
})();
